export type TouristPaymentMoment = "check_in" | "check_out";

export const TOURIST_PAYMENT_MOMENT_LABELS: Record<TouristPaymentMoment, string> = {
  check_in: "Vorkasse (Vollrechnungsentwurf bei Check-in)",
  check_out: "Zahlung bei Abreise (Rechnungsentwurf bei Check-out)",
};

export interface TouristPaymentSettings {
  moment: TouristPaymentMoment;
}

export interface BookingStayActionResponse {
  opened_invoice_id?: string | null;
}
